export default "__VITE_ASSET__BGnIw_wH__"